import { Box, Typography } from "@outschool/backpack";
import { ModalType } from "@outschool/gql-backend-generated";
import { faCheck } from "@outschool/icons";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { browseRootPath } from "@outschool/routes";
import { TrackedButton } from "@outschool/ui-components-shared";
import { Icon, Image, Modal } from "@outschool/ui-legacy-component-library";
import gql from "graphql-tag";
import React from "react";
import { useQuery } from "react-apollo";

import fullClassImage from "../../images/full-class.png";
import useModal from "../lib/useModal";
import Link from "./Link";

const WELCOME_MODAL_QUERY = gql`
  query WelcomeModalQuery {
    appState @client {
      authTrigger
      welcomeFlashMessage
    }
  }
`;

export default function WelcomeModal() {
  const { isOpen, close } = useModal(ModalType.Welcome);
  const { data, client } = useQuery(WELCOME_MODAL_QUERY);
  const { authTrigger, welcomeFlashMessage } = data?.appState || {};

  const onClose = React.useCallback(() => {
    if (isOpen) {
      client.writeData({
        data: {
          appState: {
            __typename: "AppState",
            authTrigger: null,
            welcomeFlashMessage: null
          }
        }
      });
      close();
    }
  }, [isOpen, client, close]);

  return (
    <Modal
      ariaLabel="Welcome to Outschool!"
      open={isOpen}
      sx={{ maxWidth: 400, paddingY: "large" }}
      onClose={onClose}
    >
      <Box
        sx={{
          display: "grid",
          gridRowGap: "2em",
          justifyItems: "center"
        }}
      >
        <Typography variant="h3">Welcome to Outschool!</Typography>
        {welcomeFlashMessage && (
          <Box
            sx={{
              backgroundColor: "rgba(41, 168, 119, 0.1)",
              borderColor: "rgba(41, 168, 119, 0.3)",
              color: "#29a877",
              border: "1px solid",
              borderRadius: 4,
              justifySelf: "stretch",
              textAlign: "center",
              padding: "0.5em"
            }}
          >
            <Icon icon={faCheck} />
            &nbsp; {welcomeFlashMessage}
          </Box>
        )}
        <Image sx={{ width: "100%" }} src={fullClassImage} />
        <TrackedButton
          variant="contained"
          component={Link}
          to={browseRootPath()}
          onClick={onClose}
          trackingName="welcome-modal-cta"
          trackingSharedProperties={{ authTrigger }}
        >
          See Your Class Suggestions
        </TrackedButton>
      </Box>
    </Modal>
  );
}
